import React, { useContext, useState, useEffect, useRef } from 'react';
import { UserContext } from '../betslip/UserConf';
import { getSystemBetDetails, getTicketData } from '../purchase-service';
import { ShopContext } from '../shop/ShopConf';
import { addPrintOverlay, isDevelopmentEnviroment, removePrintOverlay } from '../utils';
import { useFetchPsvVincPiazzSports } from '../virtual/fetchPsvVincPiazzSports';
import TicketPrinter from './TicketPrinter';
import { getLabel } from '../../data/labels';
import { TicketPrinterContext } from './TicketPrinterContext';

function TicketPrinterConf(props) {

	const ctxs = useRef({}).current;
	ctxs.userContext = useContext(UserContext);
	ctxs.shopContext = useContext(ShopContext);
	ctxs.selfContext = props.selfContext;
	
	function mustBePrintedBySocket(template){
		if(ctxs.selfContext && ctxs.selfContext.mustBePrintedBySocket){
			return ctxs.selfContext.mustBePrintedBySocket(template);
		}
		return false;
	}
	
	const [ticketPrinterContext, setTicketPrinterContext] = useState({
		ticketData : null,
		externalHtmlTicketList : [],
		externalHtmlTicket : null,
		testTicket : false,
		isCashoutPrint : false,
		terminalCopy : false,
		reprintTerminalReceipt : false,
		timeoutPrint : ctxs.shopContext.enabled? 3000: 10000,
		retry : 0,
		onPrintDone: null,
	    update : function(updt) {
			// updating temporary
			for(let ko in updt){
				const val = updt[ko];
				ctxs.ticketPrinterContext[ko] = val;
			}
			//update effectly
			setTicketPrinterContext(prev => {
                return {...prev, ...updt};
            });
        },
		reset : function(){
			let removeOverlayFunction = null;
			if(ctxs.selfContext){
				removeOverlayFunction = () => {
					  ctxs.selfContext.unfreezeAll();
				};
			}
			setTimeout(() => {
				removePrintOverlay(removeOverlayFunction);
			}, 2500);
			const externalHtmlTicketList = ctxs.ticketPrinterContext.externalHtmlTicketList;
			const nextExternalTicket = externalHtmlTicketList.shift();
			ctxs.ticketPrinterContext.update({
				ticketData : null,
				testTicket : false,
				isCashoutPrint : false,
				terminalCopy : false,
				reprintTerminalReceipt : false,
				timeoutPrint : 3000,
				retry : 0,
				externalHtmlTicket: nextExternalTicket,
				externalHtmlTicketList,
				onPrintDone: null	
			});
			
		},
		
		setPrintStart : function (){
			console.debug("SET PRINT START");
			let overlayFunction = null;
			if(ctxs.selfContext){
				overlayFunction = () => {
					  ctxs.selfContext.freezeAllPermanent(getLabel('general.printing_receipt'));
				};
			}
			addPrintOverlay(overlayFunction);
		},
		
		doRetry : function(toInvoke){
			ctxs.ticketPrinterContext.showTerminalPopupAdvice('retry', null);
			const newRetry = ctxs.ticketPrinterContext.retry + 1;
			const newTimeoutPrint = ctxs.ticketPrinterContext.timeoutPrint + 1000;
			ctxs.ticketPrinterContext.update({
				timeoutPrint : newTimeoutPrint,
				retry : newRetry
			});
			setTimeout(()=>{
				toInvoke();				
			}, 1000);
		},
		printTicket : function(ticketId, isCashout, printData, onPrintDone){
			
			// check: if this is a context of xsport_new under xshop, 
			// I should use the printTicket function linked to the xshop context: it is faster because its virtual dom is lighter than this one
			/*const thisAppIsSlave = getEnv('REACT_APP_IS_SHOP_SLAVE') && window.shopApi && window.shopApiSlave;
			const useXShopPrinterContext = appConfig.SHOP_MODE && thisAppIsSlave && window.printTicket;
			if(useXShopPrinterContext){
				// REMEMBER: THIS HAS BEEN DECLARED FROM XSHOP SHOPCONF, THEN IS LINKED TO ITS CONTEXT.
				// IN THIS REACT APP, I'VE ALREADY CHECKED IF THERE WAS A  printTicket IN ORDER TO AVOID OVERRIDING
				window.printTicket(ticketId, isCashout, printData);
				return;
			}*/			
			ctxs.ticketPrinterContext.closeTerminalPopupAdvice();
			isCashout = isCashout === null? false: isCashout;
			ctxs.ticketPrinterContext.setPrintStart();
			if(printData){
				// server has already replied with the printer data
				ctxs.ticketPrinterContext.closeTerminalPopupAdvice();
				const templateId = printData.psv? 'TICKET_PSV' : 'TICKET_PSQF';		
				if(printData.pch){
					isCashout = true;
				}
				ctxs.ticketPrinterContext.update({
					ticketData : printData,
					isCashoutPrint : isCashout,
					onPrintDone: onPrintDone
				});		
				return;
			}
			
			
			// ORDINARY WAY
			getTicketData(ticketId, ctxs.ticketPrinterContext.timeoutPrint, ctxs.userContext.getUser().sessionToken, (ticketData) =>{
				ctxs.ticketPrinterContext.closeTerminalPopupAdvice();
				const templateId = ticketData.psv? 'TICKET_PSV' : 'TICKET_PSQF';
				
				if(ticketData.pch){
					isCashout = true;
				}
				ctxs.ticketPrinterContext.update({
					ticketData : ticketData,
					isCashoutPrint : isCashout,
					onPrintDone: onPrintDone
				});
			},
			() =>{
				// error callback
				//window.printTicket('DF07E70A111F9083270C'); return; // Uncomment to print ticket after a fakePurchase
				if(ctxs.shopContext.enabled && !ctxs.ticketPrinterContext.terminalCopy){
					// this error causes a missed ticket receipt! must retry

					ctxs.ticketPrinterContext.doRetry(() => { console.debug("Retry printTicket attempt: "+ctxs.ticketPrinterContext.retry); ctxs.ticketPrinterContext.printTicket(ticketId, isCashout)}); //Always retry on error
					
					/*if(ctxs.ticketPrinterContext.retry < 10){
						// max 10 retry
						ctxs.ticketPrinterContext.doRetry(() => { ctxs.ticketPrinterContext.printTicket(ticketId, isCashout)});
					}
					else{
						ctxs.ticketPrinterContext.reset();
						// showing the error
						ctxs.ticketPrinterContext.showTerminalPopupAdvice('error', ticketId);
					}
					*/
				}
			});
		
		},
		printIsibetHorseTicket : function(ticketData){
			ticketData.isibetHorseTicket = true;
			ctxs.ticketPrinterContext.setPrintStart();
			ctxs.ticketPrinterContext.update({
				testTicket : false,
				ticketData : ticketData
			});
		},
		printMstbetHorseTicket : function(ticketData){
			ticketData.mstbetHorseTicket = true;
			if(!ticketData.idTicket) {
				ticketData.idTicket = ticketData?.ticket?.[0]?.id_ticket;
			}
			ctxs.ticketPrinterContext.setPrintStart();
			ctxs.ticketPrinterContext.update({
				testTicket : false,
				ticketData : ticketData
			});
		},
		printSystemBetDetailsTicket : function(ticketData,obfuscateTicketId=false){
			ticketData.systemBetsDetailTicket = true;
			ticketData.obfuscateTicketId = obfuscateTicketId;
			ctxs.ticketPrinterContext.setPrintStart();
			ctxs.ticketPrinterContext.update({
				testTicket : false,
				ticketData : ticketData
			});
		},
		promptPrintSystemBetDetailsTicket : function(ticketId, obfuscateTicketId=false){
			if(window.showConfirmModal) {
				window.showConfirmModal(getLabel('general.message','Message'),getLabel('printer.confirm.print_system_bets_detail','Do you want to print system bet details?'),
					() => {
						getSystemBetDetails(ticketId, ctxs.ticketPrinterContext.timeoutPrint, ctxs.userContext.getUser().sessionToken,
							(systemBetDetailsData) => {
								const ticketData = {
									idTicket: ticketId,
									...systemBetDetailsData
								}
								ctxs.ticketPrinterContext.printSystemBetDetailsTicket(ticketData,obfuscateTicketId);
							},
							() => {
								ctxs.shopContext?.showMonitorMessage(getLabel('general.error'));
								setTimeout(() => {
									ctxs.shopContext?.removeMonitorMessage();
								}, 1000);
							}
						);
					}, 
					() => {}
				)
			}
		},
		showTerminalPopupAdvice : function(type, ticketId){
			if(window.popupTerminalError){
				if(type === 'retry'){
					let retryDescr = window.language['global.print_retry'];
					retryDescr = retryDescr.replace(/{{FAILED}}/g, ctxs.ticketPrinterContext.retry);
					retryDescr = retryDescr.replace(/{{NOW}}/g, (ctxs.ticketPrinterContext.retry + 1));
					window.popupTerminalError(retryDescr, false);
				}
				else{
					let error = window.language["global.print_fail"] + " " + window.language["global.print_fail.discard"] + " " + ticketId;
					window.popupTerminalError(error, true);
				}
			}
		},
		
		closeTerminalPopupAdvice : function(){
			if(window.closePopupTerminalError){
				window.closePopupTerminalError();
			}
		},
		printTerminalCopy : function(ticketId){
			getTicketData(ticketId, null, ctxs.userContext.getUser().sessionToken, (ticketData) =>{
				const templateId = ticketData.psv? 'TICKET_PSV' : 'TICKET_PSQF';
				ctxs.ticketPrinterContext.update({
					ticketData : ticketData,
					terminalCopy : true,
					reprintTerminalReceipt : false
				});
			}, () => {});
		},
		
		reprintTerminalTicket : function(ticketId){
			getTicketData(ticketId, null, ctxs.userContext.getUser().sessionToken, (ticketData) =>{
				const templateId = ticketData.psv? 'TICKET_PSV' : 'TICKET_PSQF';
				ctxs.ticketPrinterContext.update({
					ticketData : ticketData,
					reprintTerminalReceipt : true,
					terminalCopy : false
				});
				
			}, () => {});
		},
		
		setTestTicket : function(value){
			ctxs.ticketPrinterContext.update({
				testTicket : value
			});
		},
		setTicketHtmlToBePrinted : function (externalHtmlTicket){
			ctxs.ticketPrinterContext.setPrintStart();
			ctxs.ticketPrinterContext.update({
				externalHtmlTicket : externalHtmlTicket
			});
		},
		setTicketHtmlListToBePrinted : function(externalHtmlTicketList){
			// first element
			const externalHtmlTicket = externalHtmlTicketList.shift();
			ctxs.ticketPrinterContext.setPrintStart();
			ctxs.ticketPrinterContext.update({
				externalHtmlTicket : externalHtmlTicket,
				externalHtmlTicketList : externalHtmlTicketList
			});
		}
	});
	
	ctxs.ticketPrinterContext = ticketPrinterContext;

	const loadVincPiazSport = ctxs.ticketPrinterContext?.ticketData?.psv && !ctxs.ticketPrinterContext?.ticketData?.psvGRB;
	const [psvVincPiazzSports] =  useFetchPsvVincPiazzSports(loadVincPiazSport, ctxs.shopContext);

	
	useEffect(() => {
		//exporting functions to invoke the printer from the window global object
		if(!window.printTicket && isDevelopmentEnviroment){
			window.printTicket = function(ticketId, showHtml, cashout, printData){
				ctxs.ticketPrinterContext.setTestTicket(showHtml);
				ctxs.ticketPrinterContext.printTicket(ticketId, cashout, printData);
			};
		}

		if(!window.printTerminalCopy){
			window.printTerminalCopy = function(ticketId){
				ctxs.ticketPrinterContext.printTerminalCopy(ticketId);
			};
		}

		if(!window.reprintTerminalTicket){
			window.reprintTerminalTicket = function(ticketId){
				ctxs.ticketPrinterContext.reprintTerminalTicket(ticketId);
			}
		}

		
		
		// gestione ippica isibet
		if(window.XSocket && props.selfContext && props.selfContext.appDataCommitted){
			window.XSocket.setHandlerForPushNotification(window.XSocket._PRINT_TICKET_HORSE_ISIBET.type, (data, socketCallback) => {
				let isibetTicketData = data.body;
				if(typeof isibetTicketData === 'string'){
					isibetTicketData = JSON.parse(isibetTicketData);
				}
				ctxs.ticketPrinterContext.printIsibetHorseTicket(isibetTicketData);
				socketCallback && socketCallback();
			});		
		}
		
		
	}, []);

	let loadPrinter = false;
	if(ctxs.ticketPrinterContext.ticketData){
		if(ctxs.ticketPrinterContext.ticketData.psv && !ctxs.ticketPrinterContext?.ticketData?.psvGRB){
			loadPrinter = psvVincPiazzSports.data;
		}
		else{
			loadPrinter = true;
		}
	}
	else if(ctxs.ticketPrinterContext.externalHtmlTicket){
		loadPrinter = true;
	}
	
	useEffect(() => {
		const ticketData = ctxs.ticketPrinterContext.ticketData; 
		//window.printFailed = null; // non c'e' rischio che venga chiamata sul pos in quanto non c'e' il debugger
		if(ticketData && props.apkPosLite){
			//ctxs.ticketPrinterContext.reset();
			window.printFailed = function(err){
				console.log('[PRINT ERROR]' + err);
				function printFailedFunction(){
					window.printFailed = null; // TODO: servirebbe una callback di stampa "ok" da mobilesoft per rimuovere al momento giusto la print failed
					ctxs.ticketPrinterContext.printTicket(ticketData.idTicket, false, ticketData);
				}
				ctxs.selfContext.showPrintErrorMessage(printFailedFunction);
				
			};
		}
	}, [ctxs.ticketPrinterContext.ticketData]);
	
	return (
    	<TicketPrinterContext.Provider value={ctxs.ticketPrinterContext}>
			{
				loadPrinter && ctxs.ticketPrinterContext.ticketData && (
					ctxs.ticketPrinterContext.ticketData.psv?
					<TicketPrinter mustBePrintedBySocket={mustBePrintedBySocket('TICKET_PSV')} user={ctxs.userContext.getUser()} psvVincPiazzSports={psvVincPiazzSports.data} />
					:
					<TicketPrinter mustBePrintedBySocket={mustBePrintedBySocket('TICKET_PSQF')} user={ctxs.userContext.getUser()} />
				)
			}
			{
				loadPrinter && ctxs.ticketPrinterContext.externalHtmlTicket && <TicketPrinter user={ctxs.userContext.getUser()} />
			}
			{props.children}
    	</TicketPrinterContext.Provider>
	);	
	
}

export default TicketPrinterConf;